var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"router-anim"}},[(_vm.show)?_c('InventoryManagement'):_vm._e(),(!_vm.show)?_c('InventoryItems',{on:{"editAddInv":_vm.editAddInv}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }